import axios from 'axios';
import { attachAuthInterceptors } from './httpInterceptors';
import { attachNavigationAbort } from './navigationAbort';
const environment = process.env.NODE_ENV || 'production';

const axiosInstance = axios.create({
  baseURL: environment === 'production' && '/api',
  timeout: 120000, // 1 Minute
  headers: {
    'Content-Type': 'application/json',
  },
});

// Maker-checker + 2FA challenge handling, same as utils.js `request`.
attachAuthInterceptors(axiosInstance);

// Cancel this instance's in-flight reads when the user navigates off the page
// that issued them. Attached after the auth interceptors so they keep first
// look at real HTTP failures.
attachNavigationAbort(axiosInstance);

export default axiosInstance;
